import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrsV12 from '../KasKrsV12'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ChipInput from 'material-ui-chip-input'
import { controlHasError } from '../../lib/errorHandler'
import {
  FORMA_PRAWNA_INNA_KOD,
  FORMA_PRAWNA_OPTIONS,
} from '../../lib/formaPrawnaOptions'

class IdentyfikacjaPodmiotuKulturyR2 extends React.Component {
  handleAddChip = (field, chip) => {
    const { data, onSetSectionData } = this.props
    const current = data[field] || []
    onSetSectionData(field, [...current, chip])
  }

  handleDeleteChip = (field, chip, index) => {
    const { data, onSetSectionData } = this.props
    const current = data[field] || []
    const next = [...current]
    next.splice(index, 1)
    onSetSectionData(field, next)
  }

  handleFormaPrawnaChange = ({ target: { value } }) => {
    const { onSetSectionData } = this.props
    onSetSectionData('FormaPrawnaKod', value)
    if (value !== FORMA_PRAWNA_INNA_KOD) {
      onSetSectionData('FormaPrawnaInnaOpis', '')
    }
  }

  render() {
    const { errors, data, onSetSectionData, onLoadGUS, onSetName } = this.props
    const pkd2025 = data.PKD || []
    const pkd2027 = data.PKD2007 || []
    const formaPrawnaKod = data.FormaPrawnaKod || ''
    const pokazInnaForma = formaPrawnaKod === FORMA_PRAWNA_INNA_KOD

    return (
      <ExpandablePanel title='IDENTYFIKACJA PODMIOTU'>
        <form
          name='IdentyfikacjaPodmiotuKulturyR2'
          autoComplete='off'
          className='identyfikacjaPodmiotu'
        >
          <KasKrsV12
            className='kasKrs'
            hasError={(name) => controlHasError(errors, name)}
            data={{
              NrNIP: data.NrNIP || '',
              NrKRS: data.NrKRS || '',
            }}
            onSetSectionData={(e) => {
              onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component='fieldset' className='nazwa'>
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name='NazwaFirmy'
              label='Nazwa pelna'
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={(e) => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
          <div className='formaPrawnaRow'>
            <FormControl component='fieldset' className='formaPrawna'>
              <InputLabel>Forma prawna jednostki</InputLabel>
              <Select
                error={controlHasError(errors, 'FormaPrawnaKod')}
                name='FormaPrawnaKod'
                value={formaPrawnaKod}
                onChange={this.handleFormaPrawnaChange}
              >
                {FORMA_PRAWNA_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {pokazInnaForma ? (
              <FormControl component='fieldset' className='formaPrawnaInna'>
                <TextField
                  error={controlHasError(errors, 'FormaPrawnaInnaOpis')}
                  name='FormaPrawnaInnaOpis'
                  label='Opis innej formy prawnej jednostki'
                  title={data.FormaPrawnaInnaOpis}
                  value={data.FormaPrawnaInnaOpis}
                  onChange={(e) =>
                    onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
            ) : null}
          </div>
          <FormControl component='fieldset' className='pkd'>
            <ChipInput
              error={controlHasError(errors, 'PKD')}
              InputLabelProps={{ shrink: true }}
              name='PKD'
              label='Kody PKD 2025'
              placeholder='Wpisz kod + [ENTER]'
              value={pkd2025}
              onAdd={(chip) => this.handleAddChip('PKD', chip)}
              onDelete={(chip, index) =>
                this.handleDeleteChip('PKD', chip, index)
              }
              helperText='Pojedynczy kod: 5 znakow, bez kropek'
            />
          </FormControl>
          <FormControl component='fieldset' className='pkd'>
            <ChipInput
              error={controlHasError(errors, 'PKD2007')}
              InputLabelProps={{ shrink: true }}
              name='PKD2007'
              label='Kody PKD 2007'
              placeholder='Wpisz kod + [ENTER]'
              value={pkd2027}
              onAdd={(chip) => this.handleAddChip('PKD2007', chip)}
              onDelete={(chip, index) =>
                this.handleDeleteChip('PKD2007', chip, index)
              }
              helperText='Pojedynczy kod: 5 znakow, bez kropek'
            />
          </FormControl>
          <FormControlLabel
            className='checkboxLabel'
            control={
              <Checkbox
                name='InstytucjaKultury'
                color='primary'
                checked={this.props.data.InstytucjaKultury}
                onChange={(e) =>
                  this.props.onSetSectionData(e.target.name, e.target.checked)
                }
              />
            }
            label='wersja dla instytucji kultury'
          />
          <FormControlLabel
            className='checkboxLabel'
            control={
              <Checkbox
                name='CITEstonski'
                color='primary'
                checked={this.props.data.CITEstonski}
                onChange={(e) =>
                  this.props.onSetSectionData(e.target.name, e.target.checked)
                }
              />
            }
            label='wersja dla CIT estonskiego'
          />
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotuKulturyR2
